import { readStoredJson } from "./session";

const ADMIN_ROLE_NAMES = ["admin", "superadmin"];

const normalize = (name) => String(name ?? "").trim().toLowerCase();

export const getStoredUser = () => readStoredJson("user", null);

export const getUserRoleNames = (user) => {
  const companyRoles = (user?.roles ?? []).map((role) => normalize(role?.name));
  const primaryRole = user?.role ? [normalize(user.role)] : [];
  return [...new Set([...companyRoles, ...primaryRole])].filter(Boolean);
};

// Reason: mirrors User::isSystemAdmin() on the server so screens offer only what the API allows.
export const isExistingAdmin = (user) =>
  getUserRoleNames(user).some((name) => ADMIN_ROLE_NAMES.includes(name));

export const hasAnyRole = (user, allowedRoles = []) => {
  const wanted = allowedRoles.map(normalize);
  if (wanted.includes("admin") && isExistingAdmin(user)) {
    return true;
  }
  const userRoles = getUserRoleNames(user);
  return wanted.some((name) => userRoles.includes(name));
};

// Reason: no client-side approver flag exists (can_approve lives on sidebar company data), so
// "commission earner / possible approver" = admin or holder of any company role.
export const canUseCompanyFeatures = (user) =>
  isExistingAdmin(user) || (user?.roles ?? []).some((role) => normalize(role?.name));
